import Axios from 'axios'

const consent = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  accept (patient, osData) {
    return this.axios().post('/consent-form/accept', { ...patient, osData })
  },
  updated (patient, osData) {
    return this.axios().post('/consent-form/update', { ...patient, osData })
  }
}

export default consent